export default "__VITE_ASSET__DgAD4j8h__"